import React, { Component } from "react";
import { Link } from "react-router-dom";

class LoginLink extends Component {
  render() {
    return (
      <Link className="loginlink" to="/login" stateprop={Math.random()}>
        <span className="arrow-down"></span>&nbsp;&nbsp;login
      </Link>
    );
  }
}

export { LoginLink };
